import { Yup } from 'shared/lib'

const validName = /^([a-zA-ZżźćńółęąśŻŹŚŁĆŃÓĘĄ'-]\s?)*([^\s\d][a-zA-ZżźćńółęąśŻŹŚŁĆŃÓĘĄ])$/
const validTelephoneNumber = /^[0-9]{9}$/

const schema = Yup.object().shape({
   name: Yup.string().min(3).max(32).matches(validName).required(),
   surname: Yup.string().min(3).max(32).matches(validName).required(),
   phoneNumber: Yup.string().matches(validTelephoneNumber, 'validation.telephoneNumberPattern').required(),
   email: Yup.string().required(),
})

export default schema
